



const IOTCNumberRegexp = /^IOTC[0-9]{1,6}$/


export const useIOTCNumber = () => {

    const self = {

        isValidPrimaryUvi: (uvi: string) => IOTCNumberRegexp.test(uvi),

        postProcessValue: (value: string | undefined) => value ? self.formatUvi(value) : value,

        formatUvi: (value: string) => `IOTC${`${value}`.toLocaleUpperCase().replace('IOTC', '').padStart(6, '0')}`

    }

    return self

}